<template>
    <div class="page" @touchmove.prevent>
        <div class="popup-con">
            <div class="pop-title">
                每月都可在
                <span style="color: #ffbb56">权益频道</span>
                <span>领{{ sourcePath === 'fbyqlb' ? '免息券' : '还款券' }}</span>
            </div>
            <div class="pop-desc">
                {{ sourcePath === 'fbyqlb' ? '借款前' : '还款前' }}记得先去领取哦
            </div>
            <div :class="['tab-icon', sourcePath === 'fbyqlb' ? 'tab-fb' : 'tab-hk']"></div>
            <div class="tab-pop-butn" @click="confirm">知道了</div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['sourcePath'],
    methods: {
        confirm() {
            this.$emit('OnConfirmClick');
        }
    }
};
</script>
<style lang="less" scoped>
@asserts: '../../../../assets/iconV2.5/';
.page {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 100;
    .popup-con {
        width: 303px;
        height: 380px;
        border-radius: 8px;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        .pop-title {
            margin-top: 30px;
            color: #49596c;
            font-size: 18px;
            // font-family: fzlt_bold;
            font-weight: bold;
        }
        .pop-desc {
            color: #616b78;
            font-size: 14px;
            // font-family: fzlt;
            margin-top: 8px;
        }
        .tab-icon {
            margin-top: 26px;
            width: 255px;
            height: 180px;
            background-size: 100% 100%;
        }
        .tab-fb {
            background-image: url('@{asserts}/img_popup_mianxiquan@2x.png');
        }
        .tab-hk {
            background-image: url('@{asserts}/img_popup_repayment@2x.png');
        }
        .tab-pop-butn {
            margin-top: 30px;
            width: 255px;
            height: 45px;
            background: linear-gradient(270deg, #3ca5e2 0%, #4dbaf9 100%);
            border-radius: 8px;
            text-align: center;
            line-height: 45px;
            color: #fff;
            font-size: 18px;
            // font-family: fzlt_bold;
            font-weight: bold;
        }
    }
}
</style>